// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-label img {
  width: 11.625rem;
  height: 4.5rem;
  object-fit: contain;
  margin-bottom: 1rem;
}
.network-label label {
  display: block;
}
.network-label label.clientLabel {
  font-weight: bold;
  color: #002f55;
  margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/main/components/browse-form/search-network-label/search-network-label.component.scss"],"names":[],"mappings":"AAEI;EACI,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AADR;AAII;EAEI,cAAA;AAHR;AAKQ;EACI,iBAAA;EACA,cAAA;EACA,mBAAA;AAHZ","sourcesContent":[".network-label {\n\n    img {\n        width:11.625rem;\n        height:4.5rem;\n        object-fit:contain;\n        margin-bottom:1rem;\n    }\n\n    label {\n\n        display:block;\n\n        &.clientLabel {\n            font-weight:bold;\n            color: #002f55;\n            margin-bottom:1rem;\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
